import React from 'react';

const CALENDLY_URL = 'https://calendly.com/saelma';

export default function SectionCTA({ label = 'Ready to discuss the next step?' }) {
  return (
    <div className="section-cta">
      <span>{label}</span>
      <a href={CALENDLY_URL} className="btn-primary section-cta-btn" target="_blank" rel="noreferrer">
        Book a call
      </a>
    </div>
  );
}
